import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import EmailHealthAlert from "../../components/EmailHealthAlert";
import { useEmailHealth } from "../../context/EmailHealthContext";
import { crmHeaders } from "../../utils/crmApi";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function CheckEmails() {
    const getUsername = Cookies.get("username");
    const navigate = useNavigate();
    const API_URL = BASE_URL + "/getemails";

    const [emails, setEmail] = useState([]);
    const [loading, setLoading] = useState(true);
    const {
        healthByEmail,
        getHealthForEmail,
        loading: healthLoading,
        checkedAt,
        refresh: refreshHealth,
        blockedCount,
    } = useEmailHealth();

    useEffect(() => {
        axios
            .get(API_URL, { headers: crmHeaders() })
            .then((res) => {
                setEmail(res.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log("There was an error", error);
                setLoading(false);
            });
    }, []);

    const searchTable = (e) => {
        const input = document.getElementById("search");
        const filter = input.value.toLowerCase();
        const table = document.getElementById("Table");
        const rows = table.getElementsByTagName("tr");

        for (let i = 1; i < rows.length; i++) {
            const cells = rows[i].getElementsByTagName("td");
            let match = false;

            for (let j = 0; j < cells.length; j++) {
                if (cells[j]) {
                    const cellValue = cells[j].textContent || cells[j].innerText;
                    if (cellValue.toLowerCase().indexOf(filter) > -1) {
                        match = true;
                        break;
                    }
                }
            }

            rows[i].style.display = match ? "" : "none";
        }
    };

    const selectAll = () => {
        const selAll = document.getElementById("selectAll");
        const rows = document.querySelectorAll("#Table tbody tr");

        rows.forEach((row) => {
            if (row.style.display !== "none") {
                const checkbox = row.querySelector('input[name="ids[]"]');
                if (checkbox) {
                    checkbox.checked = selAll.checked;
                }
            }
        });
    };

    const bulkEdit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const status = formData.get("action");
        const ids = formData.getAll("ids[]");

        if (status === "Delete" && ids.length === 0) {
            alert("Please select at least one email to delete.");
            return;
        }

        if (status === "Delete") {
            try {
                await Promise.all(
                    ids.map((id) =>
                        axios.delete(`${BASE_URL}/deleteemail/${id}`, {
                            headers: crmHeaders(),
                        })
                    )
                );
                toast.success("Selected emails deleted successfully.");
                setTimeout(() => {
                    navigate(0);
                }, 2000);
            } catch (error) {
                console.error("Error deleting emails:", error);
            }
        }
    };

    const blockedCountDisplay = blockedCount;

    if (loading) return <Loader />;

    return (
        <div className="container">
            <ToastContainer />
            <form onSubmit={bulkEdit}>
                <h1 className="text-light">Emails</h1>
                <br />
                <div className="row align-items-center">
                    <div className="col-sm-2">
                        <Link to="/emails/addemail">
                            <button type="button" className="btn btn-primary">
                                Add New Email
                            </button>
                        </Link>
                    </div>
                    <div className="col-sm-3">
                        <input
                            type="text"
                            className="form-control"
                            id="search"
                            placeholder="Search here..."
                            onKeyUp={searchTable}
                        />
                    </div>
                    <div className="col-sm-3">
                        <select name="action" className="p-1 m-1" style={{ width: "150px" }}>
                            <option value="Active">Active</option>
                            <option value="Deactive">Deactive</option>
                            <option value="Delete">Delete</option>
                        </select>
                        <button className="btn btn-primary">Apply</button>
                    </div>
                    <div className="col-sm-4 text-end">
                        <button
                            type="button"
                            className="btn btn-outline-light btn-sm"
                            onClick={refreshHealth}
                            disabled={healthLoading}
                        >
                            {healthLoading ? "Checking..." : "Recheck domain status"}
                        </button>
                        {checkedAt && (
                            <small className="d-block text-muted mt-1">
                                Last check: {new Date(checkedAt).toLocaleString()}
                            </small>
                        )}
                    </div>
                </div>

                {blockedCountDisplay > 0 && (
                    <div className="alert alert-danger mt-3 mb-0" role="alert">
                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        <strong>{blockedCountDisplay} email account(s)</strong> par domain block ya mail server
                        issue hai — neeche alerts dekhein.
                    </div>
                )}

                <br />
                <br />
                <table className="table table-striped table-dark" id="Table">
                    <thead>
                        <tr>
                            <th scope="col">
                                <input type="checkbox" id="selectAll" onChange={selectAll} />
                            </th>
                            <th scope="col">Host Name</th>
                            <th scope="col">Port</th>
                            <th scope="col">Email</th>
                            <th scope="col">Country</th>
                            <th scope="col">Status</th>
                            <th scope="col">Create At</th>
                            <th scope="col">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {emails.map((email) => {
                            const health =
                                getHealthForEmail(email.Email) ||
                                healthByEmail[String(email.Email || "").trim().toLowerCase()];
                            const hasIssue = health && health.status !== "ok";
                            return (
                                <React.Fragment key={email.Id}>
                                    <tr className={hasIssue ? "email-health-row-alert" : ""}>
                                        <td>
                                            <input type="checkbox" value={email.Id} name="ids[]" />
                                        </td>
                                        <td>{email.Host_Name}</td>
                                        <td>{email.Port}</td>
                                        <td>
                                            {email.Email}
                                            {hasIssue && (
                                                <EmailHealthAlert
                                                    health={health}
                                                    compact
                                                    className="ms-2"
                                                />
                                            )}
                                        </td>
                                        <td>{email.Country || "—"}</td>
                                        <td>
                                            {healthLoading && !health ? (
                                                <span className="text-muted small">Checking...</span>
                                            ) : health?.status === "ok" ? (
                                                <span className="badge bg-success">OK</span>
                                            ) : health?.status === "warning" ? (
                                                <span className="badge bg-warning text-dark">Warning</span>
                                            ) : health?.status === "blocked" ? (
                                                <span className="badge bg-danger">Blocked / Issue</span>
                                            ) : (
                                                <span className="text-muted">—</span>
                                            )}
                                        </td>
                                        <td>{email.Created_At}</td>
                                        <td>
                                            {getUsername !== email.Host_Name && (
                                                <Link to={`/emails/deleteemail/${email.Id}`}>
                                                    <i className="bi bi-trash3 text-danger"></i>
                                                </Link>
                                            )}
                                        </td>
                                    </tr>
                                    {hasIssue && (
                                        <tr className="email-health-row-alert">
                                            <td colSpan="8" className="pt-0 pb-3">
                                                <EmailHealthAlert health={health} />
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            );
                        })}
                        {emails.length === 0 && (
                            <tr>
                                <td colSpan="8" className="text-center">
                                    No records available to show.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </form>
        </div>
    );
}